import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { sendWelcomeProvider } from '../services/emailService';
import './AuthPage.css';

const SignupPage = () => {
    const navigate = useNavigate();
    const { signup } = useAuth();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        password: '',
        serviceCategory: 'electrician',
        experience: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const getReadableSignupError = (error) => {
        if (!error?.code) return error?.message || 'Unable to create account.';

        if (error.code === 'auth/email-already-in-use') {
            return 'This email is already registered. Please login instead or reset password.';
        }
        if (error.code === 'auth/invalid-email') {
            return 'Please enter a valid email address.';
        }
        if (error.code === 'auth/weak-password') {
            return 'Password is too weak. Use at least 6 characters.';
        }
        if (error.code === 'auth/operation-not-allowed') {
            return 'Email/password sign-up is not enabled in Firebase Authentication.';
        }

        return error.message || 'Unable to create account.';
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setError('');
            setLoading(true);
            await signup(
                formData.email,
                formData.password,
                formData.name,
                formData.phone,
                formData.serviceCategory,
                formData.experience
            );
            try {
                await sendWelcomeProvider(formData.email, {
                    providerName: formData.name,
                    name: formData.name,
                    loginEmail: formData.email,
                    serviceCategory: formData.serviceCategory,
                    experience: formData.experience,
                    loginUrl: 'https://serviceprovider.skillhives.co.in/login',
                    accountCreatedByAdmin: false,
                });
            } catch (emailError) {
                console.error('Provider welcome email failed:', emailError);
            }
            navigate('/dashboard');
        } catch (error) {
            setError(getReadableSignupError(error));
        }
        setLoading(false);
    };

    return (
        <div className="auth-page">
            <div className="auth-page-container">
                <div className="auth-page-content">
                    <div className="auth-page-header">
                        <h2>Service Partner Registration</h2>
                        <p>Join as a service partner and start earning</p>
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <form onSubmit={handleSubmit} className="auth-page-form">
                        <div className="form-group">
                            <label htmlFor="name">Full Name *</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                placeholder="Enter your name"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email Address *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                placeholder="your@email.com"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone">Phone Number *</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                                placeholder="+91 XXXXX XXXXX"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">Password *</label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                                placeholder="Enter password"
                                minLength="6"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="serviceCategory">Service Category *</label>
                            <select
                                id="serviceCategory"
                                name="serviceCategory"
                                value={formData.serviceCategory}
                                onChange={handleChange}
                                required
                            >
                                <option value="electrician">Electrician</option>
                                <option value="plumber">Plumber</option>
                                <option value="carpenter">Carpenter</option>
                                <option value="painter">Painter</option>
                                <option value="cleaner">Cleaner</option>
                                <option value="hvac">HVAC Technician</option>
                                <option value="gardener">Gardener</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="experience">Years of Experience *</label>
                            <input
                                type="number"
                                id="experience"
                                name="experience"
                                value={formData.experience}
                                onChange={handleChange}
                                required
                                placeholder="e.g., 5"
                                min="0"
                                max="50"
                            />
                        </div>

                        <button type="submit" className="btn btn-primary btn-lg auth-submit" disabled={loading}>
                            {loading ? 'Creating Account...' : 'Create Account'}
                        </button>
                    </form>

                    <div className="auth-page-footer">
                        <p>
                            Already have an account?{' '}
                            <button className="switch-btn" onClick={() => navigate('/login')}>
                                Login
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignupPage;
